import {
  GreyGrey30,
  GreyGrey70,
  GreyGrey90,
  Primary13Regular,
  StatTile,
  TextOverflow,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { dateTimeWithFormat, formatScheduleEndDate } from '@sequencehq/utils'
import { useAtomValue } from 'jotai'
import { FC, ReactNode } from 'react'
import { renewalReviewAtom } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/executeQuote.atoms'
import { phaseDateFormat } from 'modules/Cube/cube.constants'
import { CustomerPreviewCardPill } from 'Customer/components/CustomerPreviewCard'

export const ExecuteQuoteReviewStep: FC = () => {
  const review = useAtomValue(renewalReviewAtom)

  if (!review) {
    return null
  }

  return (
    <Flex flexDir="column" gap="16px" data-testid="modal.executeQuote.review">
      <Grid gridTemplateColumns="1fr 1fr" gap="12px">
        <StatTile
          label="Renewal date"
          value={dateTimeWithFormat(review.renewalDate, phaseDateFormat)}
        />
        <StatTile label="Duration" value={review.duration} />
      </Grid>
      <Flex flexDir="column">
        <DetailRow
          label="Customer"
          value={
            <CustomerPreviewCardPill
              customerId={review.customerId}
              variant="ghost"
            />
          }
        />
        <DetailRow
          label="Original start date"
          value={dateTimeWithFormat(review.originalStartDate, phaseDateFormat)}
        />
        <DetailRow
          label="Original end date"
          value={formatScheduleEndDate(review.originalEndDate)}
        />
        <DetailRow label="New end date" value={review.newEndDate} />
      </Flex>
    </Flex>
  )
}

const DetailRow = (props: { label: ReactNode; value: ReactNode }) => {
  return (
    <Grid
      gridTemplateColumns="auto 1fr"
      {...Primary13Regular}
      height="32px"
      alignItems="center"
      _notLast={{
        borderBottom: `1px solid ${GreyGrey30}`
      }}
    >
      <GridItem color={GreyGrey70} height="fit-content" userSelect="none">
        {props.label}
      </GridItem>
      <Flex height="fit-content" justifyContent="flex-end" color={GreyGrey90}>
        {typeof props.value === 'string' ? (
          <TextOverflow>{props.value}</TextOverflow>
        ) : (
          props.value
        )}
      </Flex>
    </Grid>
  )
}
